import { api_request } from '../axios_client';
import { handleError } from '../common';
import * as Constants from '../constants';

const isSI = true;
const v1SiGrnGrnDetailsIdGet = async (id, options) => {
  const resourcePath = `${Constants.PATH.SALES.GRN.grnIdDetails}/${id}`;
  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiGrnCreateSearchGet = async (po_number, so_number, options) => {
  const resourcePath = `${Constants.PATH.SALES.GRN.createSearch}`;
  so_number = so_number?.[0];
  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params: po_number ? { po_number } : { so_number },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiGrnSampleGrnGet = async (grn_id, options) => {
  const resourcePath = `${Constants.PATH.SALES.GRN.sampleGRN}`;
  try {
    const res = await api_request({
      methodType: 'get',
      params: { grn_id },
      resourcePath,
      options,
      isSI,
      responseType: 'blob'
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiGrnListGet = async (params, signal, options) => {
  const resourcePath = `${Constants.PATH.SALES.GRN.list}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params,
      data: options,
      signal,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiEoGrnListGet = async (params, signal, options) => {
  const resourcePath = `${Constants.PATH.SALES.GRN.eoList}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params,
      data: options,
      signal,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiGrnSummaryGet = async (params, signal, options) => {
  const resourcePath = `${Constants.PATH.SALES.GRN.summary}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params,
      data: options,
      signal,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiEoGrnSummaryGet = async (params, signal, options) => {
  const resourcePath = `${Constants.PATH.SALES.GRN.eoSummary}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params,
      data: options,
      signal,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiGrnFiltersGet = async (signal, options) => {
  const resourcePath = `${Constants.PATH.SALES.GRN.filters}`;
  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      signal,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiEoGrnFiltersGet = async (signal, options) => {
  const resourcePath = `${Constants.PATH.SALES.GRN.eoFilters}`;
  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      signal,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiGrnCreatePost = async (data, po_id, so_id, invoice_type, options) => {
  const resourcePath = `${Constants.PATH.SALES.GRN.createGRN}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params: { po_id, so_id, invoice_type },
      data,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiGrnSkuSubmitPost = async (grn_id, grn_file_uri, data, options) => {
  const resourcePath = `${Constants.PATH.SALES.GRN.submitSKU}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      data,
      params: { grn_id, grn_file_uri },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiGrnSkuValidatePost = async (grn_id, file, options) => {
  const resourcePath = `${Constants.PATH.SALES.GRN.validateSKU}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params: { grn_id },
      data: { file },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiGrnUploadAttachmentPost = async (grn_id, file, fileType, options) => {
  const resourcePath = `${Constants.PATH.SALES.GRN.uploadAttachment}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params: { grn_id, file_type: fileType },
      data: { file },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiGrnCancelIdPut = async (id, reason, options) => {
  const resourcePath = `${Constants.PATH.SALES.GRN.cancelGRN}/${id}`;
  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      params: { reason, id },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiGrnCloseIdPut = async (id, options) => {
  const resourcePath = `${Constants.PATH.SALES.GRN.closeGRN}/${id}`;
  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

export {
  v1SiGrnGrnDetailsIdGet,
  v1SiGrnCreateSearchGet,
  v1SiGrnSampleGrnGet,
  v1SiGrnListGet,
  v1SiGrnSummaryGet,
  v1SiGrnFiltersGet,
  v1SiGrnCreatePost,
  v1SiGrnCancelIdPut,
  v1SiGrnCloseIdPut,
  v1SiGrnSkuSubmitPost,
  v1SiGrnSkuValidatePost,
  v1SiGrnUploadAttachmentPost,
  v1SiEoGrnListGet,
  v1SiEoGrnSummaryGet,
  v1SiEoGrnFiltersGet
};
